export default "__VITE_PUBLIC_ASSET__1f1f43fe__"